export default (obj) => {
    return `
        <section  id="module__cards_${obj.id}" class="module__cards ${obj.cardDesign} p-md-0 justify-content-md-center">
            <div class="container p-md-0">
                <div class="row">
                    <div class="col"><h1 class="card__module__title">${obj.title}</h1></div>
                </div>
                <div class="cards" id="cards_${obj.id}">

                </div>
                <div class="row">
                    <div class="col text-center">
                        <div class="card__more__container">
                            <a class="simple-button-plugin" href="${obj.morelink}">${obj.moretitle} <span class="material-icons-outlined news__more__icon">&#xE5C8;</span></a>
                        </div>
                    </div>
                </div>
            </div>
        </section>`;
    
}

export const carditem = (obj) => {
    return `
        <a class="card__item" href="${obj.link}">
            ${obj.image}
            <div class="card__content">
                <span class="material-icons-outlined menu-icon"></span><span class="card__title">${obj.title}</span>
                <!--p class="card__text">${obj.intro}</p-->
            </div>
        </a>
    `;
}